module.exports = __webpack_public_path__ + "img/history.0c70e9da.png";